import React from "react";
import Header from "../../Header/Header";
import Footer from "../../Footer/Footer";
import ConstructionEquipmentGlassBanner from "../../../Assets/Product_Images/ConstructionEquipmentGlass/ConstructionEquipmentGlassBanner.jpg";
import ConstructionEquipmentGlass1 from "../../../Assets/Product_Images/ConstructionEquipmentGlass/ConstructionEquipmentGlass1.jpg";
import ConstructionEquipmentGlass2 from "../../../Assets/Product_Images/ConstructionEquipmentGlass/ConstructionEquipmentGlass2.jpg";
import ConstructionEquipmentGlass3 from "../../../Assets/Product_Images/ConstructionEquipmentGlass/ConstructionEquipmentGlass3.jpg";
import ConstructionEquipmentGlass4 from "../../../Assets/Product_Images/ConstructionEquipmentGlass/ConstructionEquipmentGlass4.jpeg";
import ConstructionEquipmentGlass5 from "../../../Assets/Product_Images/ConstructionEquipmentGlass/ConstructionEquipmentGlass5.jpeg";
import ConstructionEquipmentGlass6 from "../../../Assets/Product_Images/ConstructionEquipmentGlass/ConstructionEquipmentGlass6.jpeg";
import ConstructionEquipmentGlass7 from "../../../Assets/Product_Images/ConstructionEquipmentGlass/ConstructionEquipmentGlass7.jpeg";
import ConstructionEquipmentGlass8 from "../../../Assets/Product_Images/ConstructionEquipmentGlass/ConstructionEquipmentGlass8.jpeg";
// import ConstructionEquipmentGlass4 from "../../../Assets/AboutUs_Img/Bus_img.webp";
import { Link } from "react-router-dom";

const Bullet_proof = () => {
  return (
    <div>
      <Header />
      {/* banner section start  */}
      <section
        className="container-fluid common_banner"
        style={{
          backgroundImage: `url(${ConstructionEquipmentGlassBanner})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
        }}
      >
        <div className="container">
          <div className="row">
            <div className="col-lg-12 col-md-12 col-sm-12">
              <div className="common_title wow fadeInUp">
                <h2>
                  <Link
                    to="/AboutUs"
                    className="text-decoration-none text-white"
                  >
                    ABOUT US
                  </Link>{" "}
                  / <span className="text-white">Road & Construction Equipment Glass</span>
                </h2>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* banner section end */}

      {/* about tabbing section start  */}
      <section className="container-fluid about_Products_section">
        <div className="container">
          <div className="row">
            <div className="col-lg-12 col-md-12 col-sm-12">
              <div className="blog_text wow fadeInUp">
                <h5
                  style={{
                    color: "#153fa4",
                    fontFamily: "Segoe UI, sans-serif",
                    fontSize: "40px",
                    fontWeight: "700",
                    marginBottom: "15px",
                  }}
                >
                  Road & Construction Equipment Glass
                </h5>
                <p>
                  Engineered to endure the severe conditions and demanding
                  requirements seen on construction sites, construction
                  equipment glass is designed to withstand debris hits, fast
                  temperature changes, and operating vibrations. This glass is
                  usually found in heavy equipment including cranes, bulldozers,
                  and excavators.
                </p>
                <p>
                  Laminated and tempered variations are most often found in this
                  field. Tempered glass offers great impact resistance;
                  laminated glass provides the benefit of holding together
                  should it break. Many producers further include polycarbonate
                  or multi-layer composites to improve strength and shatter
                  resistance.
                </p>
                <p>
                  The design of Road & Construction Equipment Glass is mostly
                  influenced by operator safety and visibility. To improve
                  operator comfort and safety, these glasses typically include
                  UV filters and scratch-resistant coatings. Moreover, their
                  design guarantees visibility in dusty, muddy, or high-glare
                  situations, therefore sustaining the ongoing efficiency of
                  construction projects.
                </p>


              </div>
              <div className="Products_img gap-5 mt-5 wow fadeInUp">
                {/* <img src={ConstructionEquipmentGlass1} style={{width : "180px" , height : "190px"}} alt="Bus" /> */}
                {/* <img src={ConstructionEquipmentGlass4} style={{width : "220px" , height : "220px"}} alt="staff-bus" /> */}
                <img src={ConstructionEquipmentGlass3} style={{width : "180px" , height : "180px"}} alt="staff-bus" />
                <img src={ConstructionEquipmentGlass2} style={{width : "180px" , height : "180px"}} alt="car" />
                <img src={ConstructionEquipmentGlass5} style={{width : "180px" , height : "180px"}} alt="car" />
                <img src={ConstructionEquipmentGlass6} style={{width : "180px" , height : "180px"}} alt="car" />
                <img src={ConstructionEquipmentGlass7} style={{width : "180px" , height : "180px"}} alt="car" />
                <img src={ConstructionEquipmentGlass8} style={{width : "180px" , height : "180px"}} alt="car" />
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* about tabbing section End */}

      <Footer />
    </div>
  );
};

export default Bullet_proof;
